var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7H6V19C6 20.6569 7.34315 22 9 22H15C16.6569 22 18 20.6569 18 19V7ZM10.0303 11.0798C9.73745 10.7869 9.26257 10.7869 8.96968 11.0798C8.67678 11.3727 8.67677 11.8475 8.96966 12.1404L10.9394 14.1102L8.9697 16.0798C8.67681 16.3727 8.67682 16.8476 8.96972 17.1405C9.26261 17.4334 9.73749 17.4334 10.0304 17.1405L12 15.1708L13.9696 17.1405C14.2625 17.4334 14.7374 17.4334 15.0303 17.1405C15.3232 16.8476 15.3232 16.3727 15.0303 16.0798L13.0606 14.1102L15.0303 12.1404C15.3232 11.8475 15.3232 11.3727 15.0303 11.0798C14.7374 10.7869 14.2626 10.7869 13.9697 11.0798L12 13.0495L10.0303 11.0798Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C9.5963 3 9.23219 3.24274 9.07692 3.61538L8.91667 4H6C5.44772 4 5 4.44772 5 5C5 5.55228 5.44772 6 6 6H18C18.5523 6 19 5.55228 19 5C19 4.44772 18.5523 4 18 4H15.0833L14.9231 3.61538C14.7678 3.24274 14.4037 3 14 3H10Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trash can.9d3aa8495db042c0af4949b40807d47f.svg";
export { ForwardRef as ReactComponent };